/**
 * Utility class to check device capabilities.
 */
export default class Capabilities {
    /**
     * Check if the device supports touch interactions.
     *
     * Can be, but not exclusive to, a mobile device.
     *
     * @returns {boolean|*}
     */
    static hasTouchSupport() {
        return (
            'ontouchstart' in window ||
            (window.DocumentTouch && document instanceof window.DocumentTouch) ||
            window.navigator.maxTouchPoints > 0 ||
            window.navigator.msMaxTouchPoints > 0
        );
    }

    /**
     * Check if a device supports a mouse/pointer.
     *
     * @returns {boolean}
     */
    static hasPointerSupport() {
        return matchMedia('(pointer:fine)').matches;
    }
}
